<template>
  <div :class="{ hidden: hidden }" class="pagination-container">
    <el-pagination
      :background="background"
      :current-page.sync="currentPage"
      :page-size.sync="pageSize"
      :layout="layout"
      :page-sizes="pageSizes"
      :pager-count="pagerCount"
      :total="total"
      v-bind="$attrs"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    />
  </div>
</template>

<script>
// import { scrollTo } from '@/utils/scroll-to'

export default {
  name: 'Pagination',
  props: {
    total: {
      required: true,
      type: Number,
      default: 0,
    },
    page: {
      type: Number,
      default: 1,
    },
    limit: {
      type: Number,
      default: 10,
    },
    pageSizes: {
      type: Array,
      default() {
        // return [10, 20, 30, 50, 100];
        return [10, 20, 50, 100, 500, 1000]
      },
    },
    // 移动端页码按钮的数量端默认值5
    pagerCount: {
      type: Number,
      default: document.body.clientWidth < 992 ? 5 : 7,
    },
    layout: {
      type: String,
      default: 'total, sizes, prev, pager, next, jumper',
    },
    background: {
      type: Boolean,
      default: true,
    },
    autoScroll: {
      type: Boolean,
      default: true,
    },
    hidden: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    currentPage: {
      get() {
        return this.page
      },
      set(val) {
        this.$emit('update:page', val)
      },
    },
    pageSize: {
      get() {
        return this.limit
      },
      set(val) {
        this.$emit('update:limit', val)
      },
    },
  },
  methods: {
    handleSizeChange(val) {
      this.$emit('pagination', { page: this.currentPage, limit: val })
      if (this.autoScroll) {
        scrollTo(0, 800)
      }
    },
    handleCurrentChange(val) {
      this.$emit('pagination', { page: val, limit: this.pageSize })
      if (this.autoScroll) {
        scrollTo(0, 800)
      }
    },
  },
}
</script>

<style scoped lang="less">
@import '~@/assets/variables.less';
// $fontSize: 16px;
.pagination-container {
  /* background: #fff; */
  /*padding: 32px 16px;*/
  /* padding: 0px 15px; */
  text-align: right;
  float: right;
  transform: scale(0.86);
}
/* .pagination-container.hidden {
  display: none;
} */

.pagination-container .el-pagination {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

::v-deep .el-pagination .el-pagination__total {
  height: 40px;
  line-height: 40px;
  font-size: 16px;
}

::v-deep .el-pagination .el-pagination__sizes {
  height: 40px;
  line-height: 40px;
  .el-select {
    .el-input__inner {
      height: 40px;
      line-height: 40px;
      border-radius: @input-radius-size;
      border-color: #656d95;
      font-size: 16px;
    }
  }
}

::v-deep .el-pagination .btn-prev {
  height: 40px;
  width: 86px;
  line-height: 40px;
  display: flex;
  align-items: center;
  // background: #2f4cdd !important;
  padding: 0 8px;
  justify-content: space-around;
  display: flex;
  align-items: center;
  border-radius: @btn-radius-size;
  &::before {
    content: '';
    width: 10px;
    height: 10px;
    // background: url('../../assets/img/prev.png') no-repeat;
    background-size: 100%;
  }
  .el-icon {
    &::before {
      font-size: 16px !important;
    }
    &::after {
      font-size: 16px !important;
    }
  }
  span {
    font-family: 'PingFang SC';
    font-style: normal;
    font-weight: 400;
    font-size: 16px !important;
    border-radius: @input-radius-size;
    height: 40px;
    line-height: 40px;
    color: #fff;
    display: inline-block;
  }
}

::v-deep .el-pagination .btn-next {
  width: 86px;
  height: 40px;
  line-height: 40px;
  // background: #2f4cdd !important;
  padding: 0 8px;
  display: flex;
  align-items: center;
  justify-content: space-around;
  border-radius: @btn-radius-size;
  &::after {
    content: '';
    width: 10px;
    height: 10px;
    // background: url('../../assets/img/next.png') no-repeat;
    background-size: 100%;
    margin-right: 4px;
  }
  .el-icon {
    &::before {
      font-size: 16px !important;
    }
    &::after {
      font-size: 16px !important;
    }
  }
  span {
    font-family: 'PingFang SC';
    font-style: normal;
    font-weight: 400;
    font-size: 16px !important;
    border-radius: @input-radius-size;
    height: 40px;
    line-height: 40px;
    color: #fff;
    display: inline-block;
  }
}

// 按钮禁用
::v-deep .el-pagination .btn-prev {
  height: 40px;
  line-height: 40px;
  background: #b7b7b7 !important;
  padding: 0 8px;
  display: flex;
  align-items: center;
  border-radius: @btn-radius-size;
  &:disabled {
    span {
      font-family: 'PingFang SC';
      font-style: normal;
      font-weight: 400;
      font-size: 16px !important;
      height: 40px;
      line-height: 40px;
      color: #fff;
      display: inline-block;
    }
  }
}

::v-deep .el-pagination .btn-next {
  height: 40px;
  line-height: 40px;
  //background: #b7b7b7 !important;
  padding: 0 8px;
  display: flex;
  align-items: center;
  border-radius: @btn-radius-size;
  &:disabled {
    span {
      font-family: 'PingFang SC';
      font-style: normal;
      font-weight: 400;
      font-size: 16px !important;
      height: 40px;
      line-height: 40px;
      color: #fff;
      display: inline-block;
    }
  }
}

::v-deep .el-pagination .el-pagination__jump {
  height: 40px;
  line-height: 40px;
}

::v-deep .el-pagination .el-pager {
  display: flex;
  align-items: center;
  height: 40px;
  background: #e3e4eb;
  margin: 0 11px;
  border-radius: @btn-radius-size;
  li {
    width: 40px;
    height: 30px;
    line-height: 30px;
    background: none !important;
    font-size: 16px !important;
    color: #2f4cdd;
  }

  li.active {
    background: #fff !important;
    border-radius: @btn-radius-size;
    color: #000 !important;
  }
}
</style>
